import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from './core';
import { SharedModule } from './shared';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CheckDateValidityPipe } from './shared/pipe/check-date-validity.pipe';
import { AcknowldgementDialogComponent } from './core/acknowldgement-dialog/acknowldgement-dialog.component';
import { HomeModule } from './home/home.module';
import { ProfileModule } from './profile/profile.module';
import { WelcomepageModule } from './home/welcomepage/welcomepage.module';
import { SupportPageModule } from './shared/components/support-page/support-page.module';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    CheckDateValidityPipe,
    AcknowldgementDialogComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    SharedModule,
    SupportPageModule,
    HomeModule,
    ProfileModule,
    WelcomepageModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [],
  entryComponents: [
    AcknowldgementDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
